// HEAL-46b — возврат приложения из фона как сигнал «данные могли устареть».
//
// ЗАЧЕМ. React Query решает, обновлять ли данные, по «фокусу окна». В браузере
// это работает само, в нативной оболочке — нет: приложение уходит в фон и
// возвращается, а события фокуса WebView на iOS приходят не всегда.
//
// Это вылезло ровно на push. Человек уходил с экрана пакета, пока файлы
// обрабатывались, получал «Анализы обработаны», тапал — и видел снимок,
// снятый ДО завершения: ещё несколько секунд экран честно показывал
// «обрабатывается» (найдено на устройстве 24.09). Уведомление и приложение
// говорили разное, а верило оно приложению.
//
// Подключаем состояние приложения Capacitor к менеджеру фокуса React Query.
// Дальше каждый запрос решает сам, нужен ли ему перезапрос при возврате, —
// глобальное поведение не меняется.

import { App as CapacitorApp } from '@capacitor/app';
import { focusManager } from '@tanstack/react-query';
import { isNative } from './platform';

export function initAppFocusTracking(): void {
  if (!isNative()) return;

  void CapacitorApp.addListener('appStateChange', ({ isActive }) => {
    focusManager.setFocused(isActive);
  });
}
